export default {
  BPS_IO: {
    id: 'BPS_IO',
    mainChart: {
      name: 'bps IN/OUT',
      rscInfoList: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_' }],
    },
  },
  L4_TRAFFIC: {
    id: 'L4_TRAFFIC',
    mainChart: {
      name: 'L4 트래픽',
      rscInfoList: [{ rsctypeId: 'L4_TRAFFIC', rscId: 'TX_COUNT', rscKey: '_' }, { rsctypeId: 'L4_TRAFFIC', rscId: 'RX_COUNT', rscKey: '_' }],
    },
  },
  TRAFFIC_USERATE: {
    id: 'TRAFFIC_USERATE',
    mainChart: {
      name: '트래픽 이용률',
      rscInfoList: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_OUT', rscKey: '_' }],
    },
  },
  PACKET: {
    id: 'PACKET',
    mainChart: {
      name: '패킷 정보',
      rscInfoList: [{ rsctypeId: 'PACKET', rscId: 'UNICAST', rscKey: '_' }, { rsctypeId: 'PACKET', rscId: 'BROADCAST', rscKey: '_' }, { rsctypeId: 'PACKET', rscId: 'MULTICAST', rscKey: '_' }],
    },
    subCharts: [
      {
        id: 'PACKET_SIZE',
        name: '패킷 사이즈',
        rscInfoList: [
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_UNDER', rscKey: '_' },
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_64', rscKey: '_' },
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_65_127', rscKey: '_' },
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_128_255', rscKey: '_' },
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_256_511', rscKey: '_' },
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_512_1023', rscKey: '_' },
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_1024_1518', rscKey: '_' },
          { rsctypeId: 'PACKET_SIZE', rscId: 'SIZE_OVER', rscKey: '_' },
        ],
      },
    ],
  },
  PACKET_ERROR: {
    id: 'RADIOBAND_TRAFFIC',
    mainChart: {
      name: '패킷 에러 정보',
      rscInfoList: [
        { rsctypeId: 'PACKET_ERROR', rscId: 'ERROR_CRC', rscKey: '_' },
        { rsctypeId: 'PACKET_ERROR', rscId: 'ERROR_COLLISION', rscKey: '_' },
        { rsctypeId: 'PACKET_ERROR', rscId: 'ERROR_DROP', rscKey: '_' },
        { rsctypeId: 'PACKET_ERROR', rscId: 'ERROR_FLAGMENT', rscKey: '_' },
        { rsctypeId: 'PACKET_ERROR', rscId: 'ERROR_JABBER', rscKey: '_' },
      ],
    },
  },
  PPS_IO: {
    id: 'PPS_IO',
    mainChart: {
      name: 'pps IN/OUT',
      rscInfoList: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_OUT', rscKey: '_' }],
    },
    subCharts: [
      {
        id: 'BROADCAST',
        name: 'Broadcast',
        rscInfoList: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSB_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSB_OUT', rscKey: '_' }],
      },
      {
        id: 'MULTICAST',
        name: 'Multicast',
        rscInfoList: [{ rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSM_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPSM_OUT', rscKey: '_' }],
      },
    ],
  },
  TRAFFIC_DISCARD: {
    id: 'TRAFFIC_DISCARD',
    mainChart: {
      name: '트래픽 기각율',
      rscInfoList: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_OUT', rscKey: '_' }],
    },
  },
  TRAFFIC_ERROR: {
    id: 'TRAFFIC_ERROR',
    mainChart: {
      name: '트래픽 에러율',
      rscInfoList: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_OUT', rscKey: '_' }],
    },
  },
  TRAFFIC_ERROR_INFO: {
    id: 'TRAFFIC_ERROR_INFO',
    mainChart: {
      name: '트래픽 에러 정보\n(CRC, Collision)',
      rscInfoList: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_CRC_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_COLLISION_OUT', rscKey: '_' }],
    },
    subCharts: [
      {
        id: 'DISCARD',
        name: '기각률 IN/OUT',
        rscInfoList: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DISCARD_OUT', rscKey: '_' }],
      },
      {
        id: 'ERROR',
        name: '에러율 IN/OUT',
        rscInfoList: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_ERROR_OUT', rscKey: '_' }],
      },
      {
        id: 'DROP',
        name: 'Drop IN/OUT',
        rscInfoList: [{ rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DROP_IN', rscKey: '_' }, { rsctypeId: 'TRAFFIC_ERROR', rscId: 'TRAFFIC_DROP_OUT', rscKey: '_' }],
      },
    ],
  },
  POWER_CONSUMED: {
    id: 'POWER_CONSUMED',
    mainChart: {
      name: '전력',
      rscInfoList: [{ rsctypeId: 'POE_PORT', rscId: 'PORT_POWER_CONSUMED', rscKey: '_' }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/performance/node/analysis/netinterface/perf-chart-type.js